import { entries, filter, go, groupBy, last, map, pluck, sortBy, unique } from 'fxjs/es';
import { STORE_PRODUCT_CUSTOM_LEVEL } from '../../../../../../Creator/Product/S/constant.js';
import { CUSTOM_ALL_FOLDER_NAME } from '../../../../../../MShop/App/Product/Item/S/Constant/item.js';
import { NESS_CUSTOM_HARDCODING } from '../../../../../S/Constant/custom.js';
import { UtilStringS } from '../../../../../../Util/String/S/Function/module/UtilStringS.js';

/* 커스텀 에셋 카테고리 메뉴 리스트 */
export const getCustomAssetProductMenuList = (custom_products, folder_name) =>
  go(
    custom_products,
    filter(function filterAssetCustomLevel(product) {
      const custom_asset = UtilStringS.compareStrings(
        product._.stores_product.custom_level,
        STORE_PRODUCT_CUSTOM_LEVEL.ASSET,
      );

      const has_asset_name = last(product.image_folders)?.name != null;
      return custom_asset && has_asset_name;
    }),
    groupBy(function groupByAssetFolderName(product) {
      const image_folder = last(product.image_folders);
      return image_folder.name + '//' + image_folder.no;
    }),
    entries,
    map(([group_name, products]) => {
      const [asset_folder_name, no] = group_name.split('//');
      return {
        asset_folder_name,
        display_name: asset_folder_name,
        length: products.length,
        no: Number(no),
      };
    }),
    function addTotalMenu(menu_data) {
      const sum = menu_data.reduce((sum, { length }) => sum + length, 0);
      return [
        {
          asset_folder_name: CUSTOM_ALL_FOLDER_NAME,
          display_name: '전체 테마',
          length: sum,
          no: -999999999,
        },
        ...menu_data,
      ];
    },
    map((menu) => {
      return {
        ...menu,
        selected: menu.asset_folder_name == folder_name,
      };
    }),
    sortBy(({ no }) => no),
  );

export const getCustomProductCateList = (products, cate_list_id) => {
  return go(
    products,
    pluck('_'),
    pluck('base_product'),
    pluck('_'),
    pluck('cate_list'),
    unique,
    (cate) => {
      return [
        {
          name: '전체 상품',
          id: 'all',
        },
        ...cate,
      ];
    },
    map((cate) => {
      return {
        ...cate,
        selected: cate.id == cate_list_id,
      };
    }),
  );
};

export const getCustomData = (custom_products, domain_name, folder_name = 'all', cate_list_id = 'all') => {
  return {
    custom_filter_menu_data: getCustomAssetProductMenuList(custom_products, folder_name),
    custom_product_cate_list: getCustomProductCateList(custom_products, cate_list_id),
    ...NESS_CUSTOM_HARDCODING()[domain_name],
  };
};
